module.exports = __webpack_public_path__ + "img/shenzhen.49035100.png";